import { RefObject, useEffect } from 'react'

interface Options {
  modalRef: RefObject<HTMLElement>
  onRemoved?: () => void
}

export const useEnforceModalPresence = ({
  modalRef,
  onRemoved = () => window.location.reload(),
}: Options) => {
  useEffect(() => {
    const modalNode = modalRef.current

    if (!modalNode) {
      return undefined
    }

    // This is only UI tamper resistance. If the modal is removed from the DOM
    // via devtools, we reload so the locked state is restored. Real entitlement
    // enforcement still has to live on the backend.
    const handleModalRemoved = () => {
      if (!document.body.contains(modalNode)) {
        onRemoved()
      }
    }

    const observer = new MutationObserver(handleModalRemoved)

    observer.observe(document.body, { childList: true, subtree: true })
    const intervalId = window.setInterval(handleModalRemoved, 1000)

    return () => {
      observer.disconnect()

      window.clearInterval(intervalId)
    }
  }, [modalRef, onRemoved])
}
